export default "/_next/static/videos/d42c8a70e00d0b4a1a21476a728724bc.mp4";